import { render, staticRenderFns } from "./prompt1.vue?vue&type=template&id=7b86b112&scoped=true&"
import script from "./prompt1.vue?vue&type=script&lang=js&"
export * from "./prompt1.vue?vue&type=script&lang=js&"
import style0 from "./prompt1.vue?vue&type=style&index=0&id=7b86b112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86b112",
  null
  
)

export default component.exports